import { EditOutlined , QuestionCircleOutlined , DeleteOutlined} from "@ant-design/icons";
import { Space, Table, Drawer, Button, Popconfirm, Tag } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import holidayService from "../../../api/holiday.service";




import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EDIT_MODE, GREEN_TAG, RED_TAG } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import HolidayEntry from "./HolidayEntry";
import accountService from "../../../api/account.service";
import commonUtility from "../../../utility/Utils";









const HolidayList = () => {

  const dispatch = useDispatch();
  const state = useSelector((state)=>state.holiday)
  const [isSuccessRefreshList, setIsSuccessRefreshList] = useState(false);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);

  
  const [visible, setVisible] = useState(false);
  const [holidayList, setHolidayList] = useState([]);
  const [holidayData, setHolidayData] = useState({
    holiday_id: 0,
    type:'',
    holiday_date: '',
    holiday_description: '',
    tap_group:'',
    mode: ADD_MODE
});

  const showDrawer = (rowdata) => {
  
 //   setProgrammeCommercialData(_);
 setHolidayData({
    holiday_id : rowdata.holiday_id,
    type: rowdata.type,
    holiday_date: rowdata.holiday_date,
    holiday_description:rowdata.holiday_description,
    tap_group:rowdata.tap_group,
    mode: EDIT_MODE
  })

    setVisible(true);

  };


    const confirmDelete = (e) => {
     

      
      const data = { formdata: { holiday_id: e} };
      holidayService.deleteholiday(data).then((res) => {

        setIsSuccessRefreshList(!isSuccessRefreshList)
        if(res.response_data.affectedRows) {
       
          // message.success(res.response_msg);
          commonUtility.openNotification("bottom", "Message", res.response_msg);
        }
        else{
          //message.error(res.response_msg);
          commonUtility.openNotification("bottom", "Message", res.response_msg);
        }
        
      });


    


    };
    
    const cancel = (e) => {
      console.log("No clik",e);
      //message.error('Click on No');
    };
  

  const onClose = () => {
    setVisible(false);
  };


  


  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (selectedObj,record) => (
        <Space size="middle">
          {
            record.type == "H" ? <><Tag color={GREEN_TAG}>Holiday</Tag></> : <><Tag color={RED_TAG}>Other</Tag></>
          }
        </Space>
      )
      
    },
    {
      title: 'Date',
      dataIndex: 'holiday_date',
      key: 'holiday_date',
      sorter: (a, b) => a.holiday_date.localeCompare(b.holiday_date),
    },
    {
      title: '(Adult/Special) Coaching',
      dataIndex: 'tap_group',
      key: 'tap_group',
      sorter: (a, b) => (a.tap_group ?? '').localeCompare(b.tap_group ?? ''),
      render: (selectedObj,record) => (
        <Space size="middle">
          {
            record.tap_group == "TAPM" ? <><Tag>Adult Coaching</Tag></> : <></>
          }
          {
            record.tap_group == "TAPSC" ? <><Tag>Special Coaching</Tag></> : <></>
          }
        </Space>
      )
    },
    {
      title: 'Description',
      dataIndex: 'holiday_description',
      key: 'holiday_description',
      sorter: (a, b) => a.holiday_description.localeCompare(b.holiday_description),
    },
    
  
    {
      title: 'Action',
      key: 'action',
      width: '15%',
      render: (selectedObj) => (
        
        <Space size="middle">
          <>
              <Popconfirm
                title="Data cann't be undone if deleted. Do you want to delete? "
                icon={
                  <QuestionCircleOutlined
                    style={{
                      color: 'red',
                    }}
                  />
                }
                onConfirm={()=>confirmDelete(selectedObj.holiday_id)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button" type="danger" size="small" shape="round" >Delete <DeleteOutlined /></Button>
              </Popconfirm>
            </>

          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
  ];


  useEffect(() => {
    holidayService.list().then((res) => {
      setHolidayList(res.data.response_data);
    });
  }, [isSuccessRefreshList,state.holiday])



  return (
    <>
      <Table 
        columns={columns} 
        rowKey='holiday_id' 
        dataSource={holidayList}
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size="small"
      />


      <Drawer
          title="Edit time slot"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          {/* <TimeSlotEntry data={timeSlotData} onDrawerClose={onClose}   /> */}
          <HolidayEntry  data={holidayData} onDrawerClose={onClose} />
        </Drawer>

    </>
  );
};

export default HolidayList;